var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32.49 32.95",
    enableBackground: "new 0 0 32.49 32.95",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#646464",
    d: "M14.38,31.67H4.05C1.82,31.67,0,29.85,0,27.62V7.03c0-2.24,1.82-4.05,4.05-4.05h22.79 c2.24,0,4.05,1.82,4.05,4.05v7.65c0,0.35-0.28,0.63-0.63,0.63s-0.63-0.28-0.63-0.63V7.03c0-1.54-1.25-2.79-2.79-2.79H4.05 c-1.54,0-2.79,1.25-2.79,2.79v20.59c0,1.54,1.25,2.79,2.79,2.79h10.32c0.35,0,0.63,0.28,0.63,0.63S14.73,31.67,14.38,31.67z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#646464",
    d: "M15.45,7.21c-0.35,0-0.63-0.28-0.63-0.63V0.63C14.82,0.28,15.1,0,15.45,0s0.63,0.28,0.63,0.63v5.95 C16.08,6.93,15.8,7.21,15.45,7.21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#646464",
    d: "M24.3,7.21c-0.35,0-0.63-0.28-0.63-0.63V0.63C23.67,0.28,23.95,0,24.3,0s0.63,0.28,0.63,0.63v5.95 C24.93,6.93,24.65,7.21,24.3,7.21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#646464",
    d: "M6.6,7.21c-0.35,0-0.63-0.28-0.63-0.63V0.63C5.97,0.28,6.25,0,6.6,0s0.63,0.28,0.63,0.63v5.95 C7.23,6.93,6.95,7.21,6.6,7.21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#646464",
    cx: 6.6,
    cy: 13.26,
    r: 1.23
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#646464",
    cx: 12.36,
    cy: 13.26,
    r: 1.23
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#646464",
    cx: 18.12,
    cy: 13.26,
    r: 1.23
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#646464",
    cx: 23.88,
    cy: 13.26,
    r: 1.23
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#646464",
    cx: 6.6,
    cy: 18.82,
    r: 1.23
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#646464",
    cx: 12.36,
    cy: 18.82,
    r: 1.23
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#646464",
    cx: 6.6,
    cy: 24.38,
    r: 1.23
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#646464",
    cx: 12.36,
    cy: 24.38,
    r: 1.23
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#646464",
    d: "M24.21,32.95c-4.56,0-8.28-3.71-8.28-8.28s3.71-8.28,8.28-8.28s8.28,3.71,8.28,8.28 S28.77,32.95,24.21,32.95z M24.21,17.66c-3.87,0-7.01,3.15-7.01,7.01s3.15,7.01,7.01,7.01s7.01-3.15,7.01-7.01 S28.08,17.66,24.21,17.66z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#646464",
    d: "M26.63,27.05H23.9c-0.81,0-1.46-0.65-1.46-1.46v-3.17c0-0.8,0.65-1.46,1.46-1.46 c0.39,0,0.75,0.15,1.03,0.42c0.28,0.28,0.43,0.65,0.43,1.04v1.71h1.27c0.8,0,1.46,0.66,1.46,1.46c0,0.39-0.15,0.75-0.43,1.03 C27.38,26.9,27.02,27.05,26.63,27.05z M23.9,21.96c-0.25,0-0.46,0.21-0.46,0.46v3.17c0,0.25,0.21,0.46,0.46,0.46h2.73 c0.12,0,0.24-0.05,0.33-0.14c0.08-0.08,0.13-0.2,0.13-0.32c0-0.25-0.21-0.46-0.46-0.46h-2.27v-2.71c0-0.12-0.05-0.24-0.14-0.33 C24.14,22.01,24.02,21.96,23.9,21.96z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e287989640eee708f1423a620c7fa6ba.svg";
export { ForwardRef as ReactComponent };